import renderComponent from './renderComponent';

const NotFoundContainer = (props) => {
    return renderComponent(props);
};

export default NotFoundContainer;
